import { clearSession, getSessionGeneration, getSessionIdentity, isSessionReplaced } from '../session';
import { LOGIN_PATH, SUPPORT_ENDED_PATH } from 'router/pathName';
import { isLeavingSupport, isSupportAccessEnded } from '../supportSession';
import type { HeldSession } from './sessionLock';

/**
 * YAC-2026-009 PR7b。運営のサポートのセッションが終わった（401 support_access_ended。config/supportSession）ときは、
 * ログインの画面ではなく「サポートは終わりました」の画面（運営の画面に戻る）へ送る。
 * セッションの印は消さない（戻る（/v1/web/sessions/<sid>/support/return）は Cookie だけで送れる）。
 */
function goToSupportEnded(): void {
  if (typeof window !== 'undefined' && window.location.pathname !== SUPPORT_ENDED_PATH) {
    window.location.replace(SUPPORT_ENDED_PATH);
  }
}

/** サポートが終わった失敗なら、終わりの画面へ送って true。 */
export function leaveEndedSupport(error: unknown): boolean {
  if (!isSupportAccessEnded(error)) return false;
  // 戻っている間・戻った後に届いた、前の要求の 401 では移さない（戻った先の画面への移動を上書きしない）。
  if (!isLeavingSupport()) goToSupportEnded();
  return true;
}

/**
 * セッションを終わらせ、ログイン画面へ戻す。
 *
 * held を渡したときは、要求を送った時点のセッションのままで、その後に別のタブが
 * 更新していないときだけ印を消す。
 *  - 別のタブでログインし直していた: 消さず、このタブだけログイン画面へ戻す
 *    （このタブでログインし直した場合は、このタブはそのまま）
 *  - 同じセッションを別のタブが更新していた（Cookie は新しい）: 消さない
 */
export function endSession(held?: HeldSession): void {
  if (held) {
    const current = getSessionIdentity();
    if (current !== null && current !== held.session) {
      if (isSessionReplaced()) goToLogin();
      return;
    }
    if (current !== null && getSessionGeneration() !== held.generation) return;
  }
  clearSession();
  goToLogin();
}

export function goToLogin(): void {
  if (typeof window !== 'undefined' && window.location.pathname !== LOGIN_PATH) {
    window.location.replace(LOGIN_PATH);
  }
}
